import React, { Fragment, useState } from "react";

function FragmentInput({ steps, handler }) {
  const [fragmentInput, setfragmentInput] = useState();

  return (
    <div className="row">
      <div className="col-12">
        <Fragment>
          {steps.map((step, i) => {
            return (
              <Fragment key={i}>
                <div className="col-12">
                  <label>{`قیمت ${i + 1}`}</label>
                  <input
                    type="number"
                    className="form-control mt-2 col-6"
                    onChange={e => {
                      setfragmentInput({
                        ...fragmentInput,
                        [step.key]: e.target.value,
                      });
                    }}
                  />
                </div>
              </Fragment>
            );
          })}
          <button
            className="btn btn-success mt-3 mb-2"
            onClick={() => handler(fragmentInput)}
          >
            شکستن قیمت
          </button>
          <br />
        </Fragment>
      </div>
    </div>
  );
}

export default FragmentInput;
